import React, { useState } from 'react'
import { css, StyleSheet } from 'aphrodite'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Popover from '@material-ui/core/Popover'
import { AppTheme } from '../../../../styles/AppTheme'

export function ChatbotNodeMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const onDelete = props.onDelete
  const onDuplicate = props.onDuplicate
  const onSetStartNode = props.onSetStartNode
  const onToggleDefault = props.onToggleDefault

  const openMenu = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setAnchorEl(e.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const handleDuplicate = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    if (onDuplicate) onDuplicate()
  }

  const handleSetStartNode = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    if (onSetStartNode) onSetStartNode()
  }

  const handleToggleDefault = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    if (onToggleDefault) onToggleDefault()
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    if (onDelete) onDelete()
  }

  return (
    <div
      className={'nodrag nopan ' + css(Styles.wrap)}
      data-chatbot-node-menu='true'
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <IconButton
        size='small'
        aria-haspopup='true'
        onClick={openMenu}
        className={css(Styles.iconBtn)}
      >
        <i className={'material-icons-outlined ' + css(Styles.icon)}>more_vert</i>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={closeMenu}
        getContentAnchorEl={null}
        elevation={0}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'visible',
          },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        classes={{ paper: css(Styles.popover) }}
      >
        <div className={css(Styles.inner)}>
          {onDuplicate ? (
            <MenuItem onClick={handleDuplicate} className={css(Styles.menuItem)}>
              <i className={'material-icons-outlined ' + css(Styles.menuIcon)}>content_copy</i>
              <span>Duplicate</span>
            </MenuItem>
          ) : null}
          {onSetStartNode ? (
            <MenuItem onClick={handleSetStartNode} className={css(Styles.menuItem)}>
              <i className={'material-icons-outlined ' + css(Styles.menuIcon)}>flag</i>
              <span>Set as start step</span>
            </MenuItem>
          ) : null}
          {onToggleDefault ? (
            <MenuItem onClick={handleToggleDefault} className={css(Styles.menuItem)}>
              <i className={'material-icons-outlined ' + css(Styles.menuIcon)}>alt_route</i>
              <span>{props.defaultEnabled ? 'Remove default' : 'Add default'}</span>
            </MenuItem>
          ) : null}
          {onDelete ? (
            <MenuItem onClick={handleDelete} className={css(Styles.menuItem, Styles.menuItemDanger)}>
              <i className={'material-icons-outlined ' + css(Styles.menuIcon, Styles.menuIconDanger)}>delete</i>
              <span>Delete</span>
            </MenuItem>
          ) : null}
        </div>
      </Popover>
    </div>
  )
}

const Styles = StyleSheet.create({
  wrap: {
    display: 'flex',
    alignItems: 'center',
  },
  iconBtn: {
    padding: 4,
    borderRadius: 8,
    ':hover': {
      backgroundColor: '#F3F4F6',
    },
    ':hover i': {
      color: '#222222',
    },
  },
  icon: {
    fontSize: 18,
    color: '#6B7280',
  },
  popover: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    overflow: 'visible',
    paddingBottom: 12,
  },
  inner: {
    padding: 4,
    minWidth: 120,
    boxShadow: '3px 6px 43px rgba(0, 0, 0, 0.05)',
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: 12,
    backgroundColor: AppTheme.secondaryBg,
  },
  menuItem: {
    fontSize: 13,
    color: '#6E84A3',
    padding: '6px 10px',
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuItemDanger: {
    color: '#E53935',
  },
  menuIcon: {
    fontSize: 18,
    color: '#6B7280',
  },
  menuIconDanger: {
    color: '#E53935',
  },
})
